import GameScreen from '../components/GameScreen';
import useViewportScale from '../hooks/useViewportScale';

function AnnouncingJudgeScreen({ players, currentJudgeId }) {
  const px = useViewportScale();
  const judge = players.find(p => p.id === currentJudgeId);

  return (
    <GameScreen
      backgroundImage="/waiting-bg1.png"
      title={'Introducing our judge!'}
      introSound="/New Judge.m4a"
      contentPosition='top'
      featuredPlayer={judge}
      featuredPlayerSize={px(450)}
      players={players}
    />
  );
}

export default AnnouncingJudgeScreen;
